import { termsConditionList } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getTermsConditionList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(termsConditionList.termsConditionListBase, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTermsConditionObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${termsConditionList.termsConditionListBase}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTermsConditionOptions() {
    return new Promise((resolve, reject) => {
      axios
        .options(`${termsConditionList.termsConditionListBase}`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  uploadTermsConditionDocument(payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(
          `${termsConditionList.termsConditionListBase}${payload.id}/upload/`,
          payload.data
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  addTermsCondition(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(termsConditionList.termsConditionListBase, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  deleteDocument(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${termsConditionList.termsConditionListBase}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateTermsCondition(payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          `${termsConditionList.termsConditionListBase}${payload.id}/`,
          payload.data
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  getTermsConditionDetails(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${termsConditionList.termsConditionListBase}get_terms_condition_details/`,
          {
            params: params,
          }
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
